export default "__VITE_ASSET__1fe686ae__"